import { SEO } from './components/SEO'
import { AtelioLanding } from './components/AtelioLanding'

function App() {
  return (
    <>
      <SEO
        title="Atelio — Notas de obra y statements para tus aplicaciones"
        description="Sube tu obra y Atelio redacta las notas por pieza y el artist statement para tu aplicación — basados en lo que de verdad hay en tu trabajo. En español o inglés."
        image="https://atelio.altuzar.dev/og-image.png"
        url="https://atelio.altuzar.dev/"
      />

      <AtelioLanding />
    </>
  )
}

export default App
